<ion-content>
	<ion-row class="center">
		<ion-spinner></ion-spinner>
	</ion-row>
</ion-content>
